<template>
  <div class="question-group" :class="showGroup ? '' : 'hidden' " >
    <div class="typography group-heading" v-if="group.title[langCode]">
      <h2 v-html="group.title[langCode] " />
    </div>

    <panel-component :panel=panel v-for="panel in panels.panels"></panel-component>

  </div>
</template>

<script lang="ts" setup>
import QuestionGroup from "../models/QuestionGroup";

import {inject, reactive, ref, watch} from "vue";
import QuestionDisplayPolicy from "../QuestionDisplayPolicy";
import Manager from "../../../core/Manager";
import {getLocale} from "../../../core/Utils";
import Panels from "../Panels";
import PanelComponent from "./PanelComponent.vue";

const props = defineProps({
  group: QuestionGroup
});

const panels = new Panels(props.group.questions);

const submission = reactive(Manager.getInstance().submission);

const showGroup = ref(false);
const langCode = ref(getLocale())

const updateShowGroup = function () {
  for (let index in props.group.questions) {
    const currentQuestion = props.group.questions[index]
    showGroup.value = (new QuestionDisplayPolicy)
        .setBranch("root")
        .setQuestion(currentQuestion)
        .setStartingQuestion(1)
        .setSubmission(submission)
        .apply();
    if (showGroup.value) {
      break;
    }
    showGroup.value = false
  }
}

updateShowGroup()

watch(submission, () => {
  updateShowGroup()
})

</script>
